// Minimal scroll lock - doesn't interfere with Dawn's animations
(function() {
  let scrollPosition = 0;
  
  // Wait for Dawn's MenuDrawer to be defined
  function init() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          const details = mutation.target;
          
          if (details.hasAttribute('open')) {
            // Opening
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            document.documentElement.classList.add('drawer-open');
            document.body.classList.add('drawer-open');
            document.body.style.top = `-${scrollPosition}px`;
          } else {
            // Closing - wait a tiny bit for animation
            setTimeout(() => {
              document.documentElement.classList.remove('drawer-open');
              document.body.classList.remove('drawer-open');
              document.body.style.top = '';
              window.scrollTo(0, scrollPosition);
            }, 10);
          }
        }
      });
    });
    
    const details = document.querySelector('header-drawer details');
    if (details) {
      observer.observe(details, { attributes: true });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();